import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types'
import MyMaterialTable from '../../../components/table';
import { PapiroConsole } from "src/utils/papiroConsole";
import * as ClientPortalService from "../../../services/clientportal.service"
import { browserHistory } from "src/helpers/history";
import { bindActionCreators } from "redux";
import { injectIntl } from "react-intl";
import { withStyles } from "@mui/styles";
import { Styles } from "src/styles/material-styles";
import * as componentActions from '../../../redux/actions/calleds';

class ClientPortalTab extends Component {
    constructor(props) {
        super(props)

        this.state = {
            clientPortalList: []
        }
        this.handleItemListClick = this.handleItemListClick.bind(this)
    }

    async componentDidMount() {
        const { configId, setLoading, setMessage, intl } = this.props
        setLoading(true)

        const result = await ClientPortalService.getByConfigId(configId)

        if (result && result.success == true) {
            this.setState({ clientPortalList: [result.data] })
            setLoading(false)
        } else {
            const error = result && result.errors && result.errors[0] ? result.errors[0] : intl.formatMessage({ id: "process.error" })
            setLoading(false)
            setMessage(true, 'error', error)
        }
    }

    handleItemListClick = () => {
        this.props.history.push(`/${this.props.lang}/client-portal`)
    }

    render() {
        const { intl } = this.props
        return (
            <div>
                <MyMaterialTable
                    title={intl.formatMessage({ id: 'mail.box.config.list' })}
                    rowClick={(event, rowData) => {
                        this.handleItemListClick()
                    }}
                    columns={[
                        { title: intl.formatMessage({ id: "id" }), field: 'id' },
                        { title: intl.formatMessage({ id: "title" }), field: 'title' },
                    ]}
                    data={this.state.clientPortalList}
                />
            </div>
        )
    }
}

ClientPortalTab.prototypes = {
    configId: PropTypes.number.isRequired,
    classes: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    setLoading: PropTypes.func.isRequired,
    setMessage: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
}

export default injectIntl(connect(null, null)(withStyles(Styles)(ClientPortalTab)))